import { render, staticRenderFns } from "./DataTable-Superadmin.vue?vue&type=template&id=080704dc"
import script from "./DataTable-Superadmin.vue?vue&type=script&lang=js"
export * from "./DataTable-Superadmin.vue?vue&type=script&lang=js"
import style0 from "./DataTable-Superadmin.vue?vue&type=style&index=0&id=080704dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports